// ar阿拉伯语
export default {
    CustomSelect: {
        '请选择': 'اختر',
    },
    TopNav: {
        '创作者': 'منشئ',
        '游客': 'زائر',
        '请登录后体验完整功能': 'سجل الدخول لتجربة الوظائف الكاملة',
        '登录': 'تسجيل الدخول',
        '免费试用': 'تجربة مجانية',
        '退出登录': 'تسجيل الخروج',
        '个人中心': 'حسابي',
        '我的视频': 'مقاطع الفيديو الخاصة بي',
        '额度管理': 'إدارة الرصيد',
        '首页': 'الرئيسية',
        'AI创作': 'الإنتاج بالذكاء الاصطناعي',
        '多参考': 'مراجع متعددة',
        '文本视频': 'نص إلى فيديو',
        '图片视频': 'صورة إلى فيديو',
        '文生图': 'نص إلى صورة',
        '图生图': 'صورة إلى صورة',
        '会员中心': 'مركز العضوية',
        '概览': 'نظرة عامة',
        '我的创作': 'إبداعاتي',
        '账单管理': 'إدارة الفواتير',
        '生成任务': 'مهام التوليد',
        '价格': 'الأسعار',
        '新闻资讯': 'الأخبار',
        '确定要退出登录吗？': 'هل تريد تسجيل الخروج؟',
        '提示': 'تلميح',
        '确定': 'موافق',
        '取消': 'إلغاء',
        '退出成功': 'تم تسجيل الخروج بنجاح',
        '视频展示': 'عروض الفيديو',
    },
    AiLayout: {
        'AI创作中心': 'مركز الإنتاج بالذكاء الاصطناعي',
        '视频生成': 'توليد الفيديو',
        '图片生成': 'توليد الصورة',
        '我的作品': 'أعمالي',
        '我的创作': 'إبداعاتي',
        '今日剩余额度': 'الرصيد المتبقي اليوم',
        '多参考': 'مراجع متعددة',
        '文本视频': 'نص إلى فيديو',
        '图片视频': 'صورة إلى فيديو',
        '文生图': 'نص إلى صورة',
        '图生图': 'صورة إلى صورة',
    },
    HomeLayout: {
        '下一代AI视频生成平台': 'منصة الجيل التالي لتوليد الفيديو بالذكاء الاصطناعي، تحويل الأفكار إلى واقع فوري',
        '产品': 'المنتجات',
        'AI视频': 'فيديو بالذكاء الاصطناعي',
        '价格方案': 'خطط الأسعار',
        '新闻资讯': 'الأخبار',
        '支持': 'الدعم',
        '帮助中心': 'مركز المساعدة',
        'API文档': 'وثائق API',
        '常见问题': 'الأسئلة الشائعة',
        '法律': 'القانون',
        '服务条款': 'شروط الخدمة',
        '隐私政策': 'سياسة الخصوصية',
        '使用协议': 'اتفاقية الاستخدام',
        '版权所有': 'جميع الحقوق محفوظة',
        '客服邮箱': 'بريد الدعم',
        '复制邮箱': 'نسخ البريد',
        '开发中': 'قيد التطوير، تابعونا!',
        '链接已复制到剪贴板': 'تم نسخ الرابط إلى الحافظة',
    },
    MyLayout: {
        '创作者': 'منشئ',
        '退出登录': 'تسجيل الخروج',
        '概览': 'نظرة عامة',
        '我的创作': 'إبداعاتي',
        '会员中心': 'مركز العضوية',
        '额度管理': 'إدارة الرصيد',
        '账单管理': 'إدارة الفواتير',
        '生成任务': 'مهام التوليد',
        '确定要退出登录吗？': 'هل تريد تسجيل الخروج؟',
        '提示': 'تلميح',
        '确定': 'موافق',
        '取消': 'إلغاء',
        '退出成功': 'تم تسجيل الخروج بنجاح'
    },
    Image: {
        "文本生成图片": "نص إلى صورة",
        "图片生成图片": "صورة إلى صورة",
        "用文字描述": "صف ما تريده بالكلمات",
        "上传图片素材": "تحميل مواد الصور، يدعم توليد صور متعددة",
        "图片描述": "وصف الصورة",
        "描述您想要的图片": "صف بالتفصيل محتوى الصورة التي تريد توليدها، يدعم العربية أو الإنجليزية...",
        "提示描述越详细效果越好": "تلميح: كلما كان الوصف أكثر تفصيلاً، كانت نتيجة التوليد أفضل",
        "图片素材": "مواد الصور",
        "预览图片": "معاينة",
        "上传图片": "تحميل صورة",
        "支持格式JPGPNG": "يدعم صيغ JPG، PNG",
        "最多": "الحد الأقصى",
        "张图片": "صورة(صور)",
        "超过大小限制": "يتجاوز الحد الأقصى 10 ميجابايت",
        "不是图片文件": "ملف صورة غير صالح",
        "最多上传": "الحد الأقصى للتحميل",
        "请先上传图片": "يرجى تحميل مواد الصور أولاً",
        "请选择要生成的图片": "يرجى اختيار الصورة المراد توليدها",
        "生成结果": "نتيجة التوليد",
        "重新生成成功": "تمت إعادة التوليد بنجاح",
        "模型": "نموذج الذكاء الاصطناعي",
        "请选择模型": "يرجى اختيار نموذج التوليد",
        "分辨率": "دقة الإخراج",
        "请选择分辨率": "يرجى اختيار الدقة",
        "图片比例": "نسبة العرض إلى الارتفاع",
        "补充描述": "وصف إضافي (اختياري)",
        "补充描述提示": "اختياري: صف أي تأثيرات أو أنماط إضافية تريد أن تتمتع بها الصورة",
        "开始绘制": "بدء الرسم",
        "开始生成": "بدء التوليد",
        "生成中": "جاري التوليد، يرجى الانتظار...",
        "生成成功": "تم التوليد بنجاح",
        "图片生成成功": "تم توليد الصورة بنجاح!",
        "作品已保存到我的作品": "تم حفظ العمل في قسم \"أعمالي\"",
        "继续创作": "مواصلة الإنتاج",
        "查看作品": "عرض العمل",
        "请输入图片描述": "يرجى إدخال وصف الصورة"
    },
    MyCreation: {
        '我的创作': 'إبداعاتي',
        '查看和管理您的所有作品': 'عرض وإدارة جميع أعمالك',
        '预览': 'معاينة',
        '下载': 'تحميل',
        '编辑': 'تحرير',
        '分享': 'مشاركة',
        '删除': 'حذف',
        '暂无作品': 'لا توجد أعمال',
        '去创作': 'ابدأ الإنتاج',
        '确定删除': 'تأكيد الحذف',
        '确定要删除作品': 'هل تريد حذف العمل',
        '吗？': '؟',
        '此操作不可恢复': 'هذا الإجراء لا يمكن التراجع عنه، يرجى التأكد!',
        '取消': 'إلغاء',
        '分享作品': 'مشاركة العمل',
        '复制链接': 'نسخ الرابط',
        '全部': 'الكل',
        '视频': 'فيديو',
        '图片': 'صورة',
        '正在下载:': 'جاري التحميل: ',
        '链接已复制到剪贴板': 'تم نسخ الرابط إلى الحافظة',
        '删除成功': 'تم الحذف بنجاح'
    },
    Video: {
        "文本生成视频": "نص إلى فيديو",
        "图片生成视频": "صورة إلى فيديو",
        "智能视频生成": "توليد فيديو ذكي",
        "输入文字描述": "أدخل وصفاً نصياً",
        "上传1-9张图片": "تحميل 1-9 صور",
        "上传图片视频音频": "تحميل صورة/فيديو/صوت",
        "视频描述": "وصف الفيديو",
        "描述您想要的视频场景": "صف مشهد الفيديو الذي تريده",
        "提示": "تلميح",
        "图片素材": "مواد الصور",
        "最多上传": "الحد الأقصى للتحميل",
        "张": "صورة(صور)",
        "预览": "معاينة",
        "上传图片": "تحميل صورة",
        "支持格式": "يدعم صيغ JPG، PNG، حجم كل صورة لا يتجاوز 10 ميجابايت، الحد الأقصى",
        "AI": "الذكاء الاصطناعي يدمج بذكاء، وسينتج تأثيرات انتقال سلسة",
        "动态描述": "وصف الحركة",
        "描述您希望图片如何动起来": "صف كيف تريد أن تتحرك الصورة",
        "个": "عنصر(عناصر)",
        "上传视频": "تحميل فيديو",
        "上传音频": "تحميل صوت",
        "描述您希望视频呈现的效果": "صف التأثير الذي تريد أن يظهر عليه الفيديو",
        "模型": "النموذج",
        "请选择模型": "يرجى اختيار النموذج",
        "分辨率": "الدقة",
        "请选择分辨率": "يرجى اختيار الدقة",
        "宽高比": "نسبة العرض إلى الارتفاع",
        "视频时长": "مدة الفيديو",
        "生成音频": "توليد صوت",
        "开启音效": "تمكين المؤثرات الصوتية",
        "静音模式": "وضع كتم الصوت",
        "音频提示": "تلميح: سيتم استخدام الصوت المرفوع كموسيقى خلفية، وسيقوم الذكاء الاصطناعي تلقائياً بتوليد موسيقى إذا لم يتم رفع أي صوت",
        "开始生成": "بدء التوليد",
        "积分": "الرصيد",
        "生成中": "جاري التوليد",
        "生成成功": "تم التوليد بنجاح",
        "视频生成成功！": "تم توليد الفيديو بنجاح!",
        "作品已保存到": "تم حفظ العمل في قسم \"أعمالي\"",
        "继续创作": "مواصلة الإنتاج",
        "查看作品": "عرض العمل",
        "视频预览": "معاينة الفيديو",
        "关闭": "إغلاق",
        "下载视频": "تحميل الفيديو",
        "您的浏览器不支持视频播放": "متصفحك لا يدعم تشغيل الفيديو",
        "生成进度": "تقدم التوليد",
        "描述": "الوصف",
        "时长": "المدة",
        "秒": "ثانية",
        "视频素材": "مواد الفيديو",
        "音频素材": "مواد الصوت",
        "双图融合模式": "نمط دمج الصورتين",
        "开始下载视频": "بدء تحميل الفيديو",
        "请输入视频描述": "يرجى إدخال وصف الفيديو",
        "请至少上传一张图片": "يرجى تحميل صورة واحدة على الأقل",
        "请至少上传一张图片或一个视频": "يرجى تحميل صورة واحدة أو فيديو واحد على الأقل",
        "最多只能上传": "الحد الأقصى للتحميل",
        "超过": "يتجاوز",
        "限制": "الحد",
        "不是图片文件": "ملف صورة غير صالح",
        "不是视频文件": "ملف فيديو غير صالح",
        "不是音频文件": "ملف صوت غير صالح"
    },
    Forgot: {
        "找回密码": "استعادة كلمة المرور",
        "请输入您的邮箱，我们将发送验证码": "يرجى إدخال بريدك الإلكتروني، سنرسل رمز التحقق",
        "密码重置成功，请使用新密码登录": "تم إعادة تعيين كلمة المرور بنجاح، يرجى تسجيل الدخول باستخدام كلمة المرور الجديدة",
        "密码重置成功": "تم إعادة تعيين كلمة المرور بنجاح",
        "您的密码已成功重置，请使用新密码登录": "تمت إعادة تعيين كلمة المرور بنجاح، يرجى تسجيل الدخول باستخدام كلمة المرور الجديدة",
        "立即登录": "تسجيل الدخول الآن",
        "邮箱": "البريد الإلكتروني",
        "请输入注册邮箱": "يرجى إدخال البريد الإلكتروني المسجل",
        "发送验证码": "إرسال رمز التحقق",
        "请输入验证码": "يرجى إدخال رمز التحقق",
        "验证码": "رمز التحقق",
        "新密码": "كلمة المرور الجديدة",
        "设置新密码": "تعيين كلمة مرور جديدة",
        "确认新密码": "تأكيد كلمة المرور الجديدة",
        "再次输入新密码": "أدخل كلمة المرور الجديدة مرة أخرى",
        "重置密码": "إعادة تعيين كلمة المرور",
        "返回登录": "العودة إلى تسجيل الدخول",
        "验证中": "جاري التحقق",
        "重置中": "جاري إعادة التعيين",
        "弱": "ضعيف",
        "中": "متوسط",
        "强": "قوي",
        "请输入邮箱地址": "يرجى إدخال عنوان البريد الإلكتروني",
        "请输入正确的邮箱格式": "يرجى إدخال تنسيق بريد إلكتروني صحيح",
        "验证码应为6位数字": "يجب أن يتكون رمز التحقق من 6 أرقام",
        "请输入新密码": "يرجى إدخال كلمة مرور جديدة",
        "密码至少需要6位": "كلمة المرور يجب أن تتكون من 6 أحرف على الأقل",
        "请再次输入新密码": "يرجى إدخال كلمة المرور الجديدة مرة أخرى",
        "两次输入的密码不一致": "كلمتا المرور غير متطابقتين",
        "验证码已发送": "تم إرسال رمز التحقق"
    },
    Login: {
        "下一代AI视频生成平台": "منصة الجيل التالي لتوليد الفيديو بالذكاء الاصطناعي",
        "一键生成": "توليد بنقرة واحدة",
        "支持4K超高清输出": "يدعم إخراج بدقة 4K فائقة الوضوح",
        "多种风格模板任选": "اختر من بين قوالب متعددة الأنماط",
        "商用授权无忧使用": "ترخيص تجاري للاستخدام دون قلق",
        "欢迎回来": "مرحباً بعودتك",
        "登录您的账号继续创作": "سجل الدخول إلى حسابك لمواصلة الإنتاج",
        "邮箱": "البريد الإلكتروني",
        "请输入邮箱地址": "يرجى إدخال عنوان البريد الإلكتروني",
        "密码": "كلمة المرور",
        "请输入您的密码": "يرجى إدخال كلمة المرور الخاصة بك",
        "记住我": "تذكرني",
        "忘记密码؟": "نسيت كلمة المرور؟",
        "登录": "تسجيل الدخول",
        "登录中": "جاري تسجيل الدخول",
        "还没有账号？": "ليس لديك حساب بعد؟",
        "立即注册": "التسجيل الآن",
        "请输入正确的邮箱格式": "يرجى إدخال تنسيق بريد إلكتروني صحيح",
        "请输入密码": "يرجى إدخال كلمة المرور",
        "密码至少需要6位": "كلمة المرور يجب أن تتكون من 6 أحرف على الأقل",
        "密码不能超过20位": "لا يمكن أن تتجاوز كلمة المرور 20 حرفاً",
        "登录成功": "تم تسجيل الدخول بنجاح"
    },
    Register: {
        "创建账号": "إنشاء حساب",
        "开始您的AI视频创作之旅": "ابدأ رحلتك في إنتاج الفيديو بالذكاء الاصطناعي",
        "姓名": "الاسم",
        "请输入您的姓名": "يرجى إدخال اسمك",
        "邮箱": "البريد الإلكتروني",
        "请输入邮箱地址": "يرجى إدخال عنوان البريد الإلكتروني",
        "获取验证码": "الحصول على رمز التحقق",
        "验证码": "رمز التحقق",
        "请输入验证码": "يرجى إدخال رمز التحقق",
        "密码": "كلمة المرور",
        "设置密码": "تعيين كلمة المرور",
        "确认密码": "تأكيد كلمة المرور",
        "再次输入密码": "أدخل كلمة المرور مرة أخرى",
        "我已阅读并同意": "لقد قرأت وأوافق على",
        "服务条款": "شروط الخدمة",
        "和": "و",
        "隐私政策": "سياسة الخصوصية",
        "注册中": "جاري التسجيل",
        "已有账号？": "هل لديك حساب بالفعل؟",
        "立即登录": "تسجيل الدخول الآن",
        "弱": "ضعيف",
        "中": "متوسط",
        "强": "قوي",
        "请输入姓名": "يرجى إدخال الاسم",
        "姓名至少需要2个字符": "يجب أن يتكون الاسم من حرفين على الأقل",
        "姓名不能超过20个字符": "لا يمكن أن يتجاوز الاسم 20 حرفاً",
        "请输入正确的邮箱格式": "يرجى إدخال تنسيق بريد إلكتروني صحيح",
        "验证码应为6位数字": "يجب أن يتكون رمز التحقق من 6 أرقام",
        "请输入密码": "يرجى إدخال كلمة المرور",
        "密码至少需要6位": "كلمة المرور يجب أن تتكون من 6 أحرف على الأقل",
        "密码不能超过20位": "لا يمكن أن تتجاوز كلمة المرور 20 حرفاً",
        "请再次输入密码": "يرجى إدخال كلمة المرور مرة أخرى",
        "两次输入的密码不一致": "كلمتا المرور غير متطابقتين",
        "验证码已发送": "تم إرسال رمز التحقق",
        "注册成功": "تم التسجيل بنجاح"
    },
    Faq: {
        '常见问题': 'الأسئلة الشائعة',
        '您在使用过程中遇到的问题': 'المشاكل التي تواجهها أثناء الاستخدام، ستجد إجاباتها هنا',
        '搜索您的问题': 'ابحث عن سؤالك...',
        '没有找到相关的问题': 'لم يتم العثور على أسئلة ذات صلة',
        '查看全部问题': 'عرض جميع الأسئلة',
        '没有找到您想要的答案？': 'لم تجد الإجابة التي تبحث عنها؟',
        '我们的客服团队随时为您提供帮助': 'فريق الدعم لدينا متاح لمساعدتك في أي وقت',
        '复制客服邮箱': 'نسخ بريد الدعم',
        '链接已复制到剪贴板': 'تم نسخ الرابط إلى الحافظة'
    },
    Home: {
        '立即订阅': 'اشترك فورًا',
        'AI视频生成新时代': 'عصر جديد لتوليد الفيديو بالذكاء الاصطناعي',
        '用文字创造': 'ابتكر بالكلمات',
        '无限视频': 'فيديوهات غير محدودة',
        '让每个人都能成为视频创作者': 'تمكين الجميع من أن يصبحوا منشئي فيديو. فقط أدخل وصفاً نصياً لتحصل على فيديو عالي الجودة وفريد بالذكاء الاصطناعي.',
        '免费开始': 'ابدأ مجاناً',
        '观看演示': 'مشاهدة العرض التوضيحي',
        'AI生成': 'توليد بالذكاء الاصطناعي',
        'AI视频': 'فيديو بالذكاء الاصطناعي',
        '三步轻松生成专业视频': 'ثلاث خطوات لتوليد فيديو احترافي بسهولة',
        '输入提示词': 'أدخل كلمة توجيهية',
        '用文字描述您想要的视频内容': 'صف محتوى الفيديو الذي تريده بالكلمات، كلما كان أكثر تفصيلاً كانت النتيجة أفضل',
        '智能生成': 'توليد ذكي',
        'AI模型自动理解并创作': 'نموذج الذكاء الاصطناعي يفهم تلقائياً ويبدع، يكتمل العرض خلال دقائق',
        '下载作品': 'تحميل العمل',
        '高清视频生成完成': 'تم توليد فيديو عالي الدقة، جاهز للتحميل والاستخدام فوراً',
        'AI视频生成': 'توليد فيديو بالذكاء الاصطناعي',
        '精彩视频': 'أدخل وصفاً نصياً، وسيقوم الذكاء الاصطناعي بتوليد فيديو رائع لك',
        '描述您想要的视频场景': 'صف مشهد الفيديو الذي تريده، على سبيل المثال: قطة تلعب تحت شجرة أزهار الكرز، وأشعة الشمس تتساقط عبر البتلات...',
        '生成中': 'جاري التوليد...',
        '生成视频': 'توليد الفيديو',
        'AI图片': 'صورة بالذكاء الاصطناعي',
        '精美图片': 'أدخل وصفاً نصياً، وسيقوم الذكاء الاصطناعي بتوليد صورة رائعة لك',
        '描述您想要的图片场景': 'صف مشهد الصورة الذي تريده، على سبيل المثال: أفق مدينة المستقبل، أضواء النيون الوامضة، بأسلوب السايبربانك...',
        '生成图片': 'توليد الصورة',
        '强大功能': 'وظائف قوية',
        '让视频创作变得简单有趣': 'تجعل إنتاج الفيديو بسيطاً وممتعاً',
        '案例展示': 'عرض الحالات',
        '来看看用户使用': 'تعال لترى الأعمال الرائعة التي ابتكرها',
        '创作的精彩作品': 'المستخدمون',
        '新闻资讯': 'الأخبار',
        '了解': 'تعرف على',
        '的最新动态和产品更新': 'آخر المستجدات وتحديثات المنتجات',
        '查看更多': 'عرض المزيد',
        '热门': 'الأكثر شيوعاً',
        '最新': 'الأحدث',
        '阅读更多': 'اقرأ المزيد',
        '选择适合您的方案': 'اختر الخطة المناسبة لك',
        '灵活的定价': 'أسعار مرنة تلبي احتياجات مختلفة',
        '视频预览': 'معاينة الفيديو',
        '生成成功': 'تم التوليد بنجاح',
        '作品已保存到': 'تم حفظ العمل في قسم "إبداعاتي"',
        '继续创作': 'مواصلة الإنتاج',
        '查看作品': 'عرض العمل',
        '请输入视频描述': 'يرجى إدخال وصف الفيديو',
        '视频生成成功！': 'تم توليد الفيديو بنجاح!',
        '请输入图片描述': 'يرجى إدخال وصف الصورة',
        '图片生成成功！': 'تم توليد الصورة بنجاح!',
    },
    News: {
        '新闻资讯': 'الأخبار',
        '了解': 'تعرف على',
        '的最新动态和产品更新': 'آخر المستجدات وتحديثات المنتجات',
        '精选': 'مختارة',
        '阅读': 'اقرأ',
        '点赞': 'إعجاب',
        '热门': 'الأكثر شيوعاً',
        '最新': 'الأحدث',
        '阅读更多': 'اقرأ المزيد',
        '加载中': 'جاري التحميل...',
        '暂无新闻': 'لا توجد أخبار',
        '清除筛选': 'مسح التصفية',
        '加载新闻失败': 'فشل تحميل الأخبار، يرجى المحاولة لاحقاً',
    },
    Price: {
        '选择适合您的方案': 'اختر الخطة المناسبة لك',
        '灵活的定价': 'أسعار مرنة تلبي احتياجات مختلفة',
        '包月': 'شهري',
        '包年': 'سنوي',
        '购买积分': 'شراء الرصيد',
        '只需要几个视频': 'هل تحتاج فقط إلى بضعة مقاطع فيديو؟ لا حاجة للاشتراك، اشترِ حزمة رصيد مباشرة',
        '产品大全': 'دليل المنتجات الكامل',
        '了解': 'تعرف على',
        '全系列产品的详细信息和支付方式': 'المعلومات التفصيلية وطرق الدفع لمجموعة المنتجات الكاملة'
    },
    Billing: {
        '账单管理': 'إدارة الفواتير',
        '账户余额': 'رصيد الحساب',
        '本月支出': 'مصروفات هذا الشهر',
        '订单数量': 'عدد الطلبات',
        '账单列表': 'قائمة الفواتير',
        '请选择类型': 'يرجى اختيار النوع',
        '请选择时间范围': 'يرجى اختيار النطاق الزمني',
        '订单号': 'رقم الطلب',
        '类型': 'النوع',
        '金额': 'المبلغ',
        '状态': 'الحالة',
        '时间': 'الوقت',
        '操作': 'الإجراء',
        '查看详情': 'عرض التفاصيل',
        '下载发票': 'تحميل الفاتورة',
        '暂无作品': 'لا توجد أعمال',
        '去创作': 'ابدأ الإنتاج',
        '支付方式': 'طريقة الدفع',
        '添加支付方式': 'إضافة طريقة دفع',
        '默认': 'افتراضي',
        '设为默认': 'تعيين كافتراضي',
        '编辑': 'تحرير',
        '删除': 'حذف',
        '账单详情': 'تفاصيل الفاتورة',
        '交易流水号': 'رقم المعاملة',
        '关闭': 'إغلاق',
        '账号': 'الحساب/رقم البطاقة',
        '请输入账号或卡号': 'يرجى إدخال رقم الحساب أو البطاقة',
        '姓名': 'الاسم',
        '请输入持卡人姓名': 'يرجى إدخال اسم حامل البطاقة',
        '有效期': 'تاريخ الانتهاء',
        '请输入CVV码': 'يرجى إدخال رمز CVV',
        '取消': 'إلغاء',
        '确认添加': 'تأكيد الإضافة',
        '确认修改': 'تأكيد التعديل',
        '确认删除': 'تأكيد الحذف',
        '编辑支付方式': 'تحرير طريقة الدفع',
        '确定要删除支付方式': 'هل تريد حذف طريقة الدفع هذه',
        '删除后不可恢复': 'لا يمكن التراجع عن الحذف، يرجى التأكد!',
        '请输入账号': 'يرجى إدخال رقم الحساب/البطاقة',
        '添加成功': 'تمت الإضافة بنجاح',
        '修改成功': 'تم التعديل بنجاح',
        '已设为默认支付方式': 'تم التعيين كطريقة دفع افتراضية',
        '删除成功': 'تم الحذف بنجاح',
    },
    Credit: {
        '额度管理': 'إدارة الرصيد',
        '当前可用额度': 'الرصيد المتاح حالياً',
        '升级会员': 'ترقية العضوية',
        '本月已用': 'المستخدم هذا الشهر',
        '视频生成': 'توليد الفيديو',
        'AI图片': 'صورة بالذكاء الاصطناعي',
        '其他': 'أخرى',
        '购买额度包': 'شراء حزمة رصيد',
        '最受欢迎': 'الأكثر شيوعاً',
        '额度': 'الرصيد',
        '立即购买': 'شراء الآن',
        '使用记录': 'سجل الاستخدام',
        '操作': 'الإجراء',
        '类型': 'النوع',
        '额度变动': 'تغير الرصيد',
        '时间': 'الوقت',
        '购买': 'شراء',
        '确认购买': 'تأكيد الشراء',
        '金额': 'المبلغ: ',
        '获得': 'ستحصل على',
        '取消': 'إلغاء',
        '今天': 'اليوم',
        '昨天': 'أمس',
    },
    Dashboard: {
        '欢迎回来': 'مرحباً بعودتك،',
        '创建新视频': 'إنشاء فيديو جديد',
        '本月生成次数': 'عدد مرات التوليد هذا الشهر',
        '剩余额度': 'الرصيد المتبقي',
        '总视频数': 'إجمالي عدد الفيديوهات',
        '会员状态': 'حالة العضوية',
        '最近生成': 'أحدث التوليدات',
        '查看全部': 'عرض الكل',
        '视频预览': 'معاينة الفيديو',
        '视频生成中': 'جاري توليد الفيديو، يرجى المعاينة لاحقاً',
    },
    Membership: {
        '会员中心': 'مركز العضوية',
        '当前方案': 'الخطة الحالية',
        'Pro 会员': 'عضوية Pro',
        '专业创作者首选': 'الاختيار الأمثل للمنشئين المحترفين',
        '月': 'شهر',
        '会员有效期': 'صلاحية العضوية',
        '剩余天数': 'الأيام المتبقية',
        '续费会员': 'تجديد العضوية',
        '取消订阅': 'إلغاء الاشتراك',
        '本月使用情况': 'حالة الاستخدام هذا الشهر',
        '视频生成': 'توليد الفيديو',
        '次': 'مرة(مرات)',
        '额度使用': 'استخدام الرصيد',
        '快速生成': 'توليد سريع',
        '升级方案': 'ترقية الخطة',
        '联系销售': 'الاتصال بالمبيعات',
        '会员权益': 'مزايا العضوية',
        '30天': 'سيتم تمديد صلاحية العضوية لمدة 30 يوماً بعد التجديد',
        '取消': 'إلغاء',
        '确认续费': 'تأكيد التجديد',
        '取消后您将失去所有会员权益': 'بعد الإلغاء ستفقد جميع مزايا العضوية، وسيبقى الرصيد المتبقي',
        '再想想': 'أعد التفكير',
        '确认取消': 'تأكيد الإلغاء',
        '姓名': 'الاسم',
        '请输入您的姓名': 'يرجى إدخال اسمك',
        '请输入姓名': 'يرجى إدخال الاسم',
        '公司': 'الشركة',
        '请输入公司名称': 'يرجى إدخال اسم الشركة',
        '邮箱': 'البريد الإلكتروني',
        '请输入邮箱地址': 'يرجى إدخال عنوان البريد الإلكتروني',
        '请输入邮箱': 'يرجى إدخال البريد الإلكتروني',
        '请输入正确的邮箱格式': 'يرجى إدخال تنسيق بريد إلكتروني صحيح',
        '需求': 'الطلب',
        '请描述您的需求': 'يرجى وصف طلبك',
        '提交': 'إرسال',
        '请填写需求': 'يرجى كتابة الطلب',
        '续费成功': 'تم التجديد بنجاح! تم تمديد صلاحية العضوية',
        '已取消订阅': 'تم إلغاء الاشتراك، ستنتهي العضوية بعد انتهاء صلاحيتها',
        '提交成功': 'تم الإرسال بنجاح، سوف نتواصل معك قريباً!',
    },
    Task: {
        '生成任务': 'مهام التوليد',
        '新建任务': 'مهمة جديدة',
        '进行中': 'قيد التنفيذ',
        '已完成': 'مكتملة',
        '失败': 'فاشلة',
        '队列中': 'في قائمة الانتظار',
        '活跃任务': 'المهام النشطة',
        '刷新': 'تحديث',
        '暂无活跃任务': 'لا توجد مهام نشطة',
        '预计剩余': 'الوقت المتبقي المتوقع',
        '暂停': 'إيقاف مؤقت',
        '继续': 'استئناف',
        '取消': 'إلغاء',
        '最近完成': 'المكتملة مؤخراً',
        '查看全部': 'عرض الكل',
        '暂无完成的任务': 'لا توجد مهام مكتملة',
        '播放': 'تشغيل',
        '下载': 'تحميل',
        '分享': 'مشاركة',
        '确认取消': 'تأكيد الإلغاء',
        '确定要取消任务吗': 'هل تريد إلغاء المهمة',
        '已消耗的额度将无法退还': 'الرصيد المستهلك لن يتم استرداده',
        '返回': 'عودة',
        '分享作品': 'مشاركة العمل',
        '复制链接': 'نسخ الرابط',
        '任务列表已刷新': 'تم تحديث قائمة المهام',
        '已暂停': 'تم الإيقاف المؤقت',
        '生成中': 'جاري التوليد',
        '已恢复': 'تم الاستئناف',
        '任务已取消': 'تم إلغاء المهمة',
        '链接已复制到剪贴板': 'تم نسخ الرابط إلى الحافظة',
    },
    VideoShow: {
        '示例': 'أمثلة',
        '来自我们演示库的一套精心挑选的剪辑片段，点击任何卡片即可开始生成与之风格相似的素材。': 'مجموعة مختارة بعناية من المقاطع من مكتبة العروض التوضيحية الخاصة بنا، انقر على أي بطاقة لبدء إنشاء محتوى مشابه في الأسلوب.',
        '全部': 'الكل',
        '电影感': 'سينمائي',
        '角色': 'شخصيات',
        '产品': 'منتجات',
        '自然': 'طبيعة',
        '趣味': 'مرح',
        '加载中': 'جاري التحميل',
        '暂无展示': 'لا توجد عروض',
        '视频预览': 'معاينة الفيديو',
    },
    Request: {
        '加载中': 'جاري التحميل...',
        '您已退出登录': 'لقد قمت بتسجيل الخروج، يمكنك إعادة تسجيل الدخول',
        '确认退出': 'تأكيد تسجيل الخروج',
        '重新登录': 'إعادة تسجيل الدخول',
        '错误': 'خطأ',
        '网络错误': 'خطأ في الشبكة',
        '下载中': 'جاري التنزيل...'
    },
    Other: {
        '剩余额度': 'الرصيد المتبقي',
        '去登录': 'تسجيل الدخول',
        '请登录后查看': 'الرجاء تسجيل الدخول للمشاهدة',
        '任务': 'المهام',
        '可在「生成任务」中查看详情': '، يمكنك عرض التفاصيل في "مهام التوليد"',
        '查看详情': 'عرض التفاصيل',
        '排队中': 'في قائمة الانتظار',
        '运行中': 'قيد التشغيل',
        '取消': 'إلغاء',
        '成功': 'ناجح',
        '失败': 'فشل',
        '超时': 'انتهاء الوقت',
        '最后更新': 'آخر تحديث:',
        '视频生成': 'توليد الفيديو',
        '活跃用户': 'المستخدمين النشطين',
        '用户评分': 'تقييم المستخدمين',
        '万': 'ألف',
        '快速生成': 'توليد سريع',
        '先进的AI模型': 'نماذج ذكاء اصطناعي متقدمة، تولد فيديوهات عالية الجودة في دقائق',
        '多种风格': 'أنماط متعددة',
        '多种风格任您选择': 'أنماط واقعية، أنمي، فنية وغيرها الكثير.',
        '高清输出': 'إخراج عالي الدقة',
        '支持4K超高清视频输出': 'يدعم إخراج فيديو بدقة 4K فائقة الوضوح، تظهر التفاصيل بوضوح',
        '商用授权': 'ترخيص تجاري',
        '生成的视频可用于商业用途': 'الفيديوهات المُنشأة يمكن استخدامها للأغراض التجارية، دون مخاوف تتعلق بحقوق النشر',
        '原价': 'السعر الأصلي',
        '积分价格说明': 'شرح أسعار النقاط',
        '系列': 'السلسلة',
        '模型': 'النموذج',
        '分辨率': 'الدقة',
        '积分': 'النقاط',
        '秒': 'ثانية',
        '秒示例': 'ثانية (مثال)',
        '图片模型': 'نموذج الصور',
        '图片为': 'الصور هي',
        '系列产品': 'منتجات السلسلة، تدعم حالياً',
        '支持使用任意机型查看完整体验': '، وتدعم استخدام أي جهاز لمشاهدة التجربة الكاملة.',
        '计费方式': 'طريقة الفوترة',
        '张': 'صورة',
        '按生成张数计费': 'الفوترة حسب عدد الصور المولدة',
        '普通用户': 'المستخدم العادي',
        '无记录': 'لا توجد سجلات',
        '总支出': 'إجمالي الإنفاق',
        '月总使用': 'إجمالي الاستخدام الشهري',
        '月视频使用': 'استخدام الفيديو الشهري',
        '月图片使用': 'استخدام الصور الشهري',
        '生成成功': 'تم التوليد بنجاح',
        '视频总生成': 'إجمالي فيديوهات تم توليدها',
        '图片总生成': 'إجمالي صور تم توليدها',
        '生成中': 'جاري التوليد، يرجى الانتظار لمدة 1-3 دقائق',
        '来自我们演示库的一套精心挑选的剪辑片段': 'مجموعة مختارة بعناية من المقاطع من مكتبة العروض التوضيحية لدينا.',
        '最近7天': 'آخر 7 أيام',
        '最近30天': 'آخر 30 يومًا',
        '本月': 'هذا الشهر',
        '上月': 'الشهر الماضي',
        '选择支付方式': 'اختر طريقة الدفع',
        '确认支付': 'تأكيد الدفع'
    }
}